import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LanguageRouteParameterPart} from './shared/language';
import {environment} from "../environments/environment";

const routes: Routes = [
	{
		path: LanguageRouteParameterPart,
		loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '/' + environment.defaultLanguage,
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
